"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMandateDto = exports.CreateMandateDto = exports.MandateDetailsFromFieldsDto = exports.MandateDetailsDocumentDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
const mapped_types_1 = require("@nestjs/mapped-types");
class MandateDetailsDocumentDto {
}
exports.MandateDetailsDocumentDto = MandateDetailsDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 237,
        description: "The ID of the document type",
    }),
    (0, class_validator_1.IsInt)({ message: "documentTypeLid must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "documentTypeLid is required" }),
    tslib_1.__metadata("design:type", Number)
], MandateDetailsDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 35,
        description: "The ID of the document",
    }),
    (0, class_validator_1.IsInt)({ message: "documentId must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "documentId is required" }),
    tslib_1.__metadata("design:type", Number)
], MandateDetailsDocumentDto.prototype, "documentId", void 0);
class MandateDetailsFromFieldsDto {
}
exports.MandateDetailsFromFieldsDto = MandateDetailsFromFieldsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 330,
        description: "The ID of the mandate type",
    }),
    (0, class_validator_1.IsInt)({ message: "mandateTypeLid must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "mandateTypeLid is required" }),
    tslib_1.__metadata("design:type", Number)
], MandateDetailsFromFieldsDto.prototype, "mandateTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of contact ids associated with the mandate",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Contact is required" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    tslib_1.__metadata("design:type", Array)
], MandateDetailsFromFieldsDto.prototype, "mandateDetailsContacts", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-01-16",
        description: "The start date of the mandate validity in ISO format",
    }),
    (0, class_validator_1.IsDateString)({}, { message: "validFrom must be a valid ISO date string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "validFrom is required" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], MandateDetailsFromFieldsDto.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-12-31",
        description: "The end date of the mandate validity in ISO format",
    }),
    (0, class_validator_1.IsDateString)({}, { message: "validTo must be a valid ISO date string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "validTo is required" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], MandateDetailsFromFieldsDto.prototype, "validTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1000,
        description: "The compensation payable for the mandate",
    }),
    (0, class_validator_1.IsInt)({ message: "compensationPayable must be an integer" }),
    (0, class_validator_1.Min)(1, { message: "compensationPayable must be greater than 0" }),
    tslib_1.__metadata("design:type", Number)
], MandateDetailsFromFieldsDto.prototype, "compensationPayable", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 401,
        description: "The ID of the compensation type",
    }),
    (0, class_validator_1.IsInt)({ message: "compensationTypeLid must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "compensationTypeLid is required" }),
    tslib_1.__metadata("design:type", Number)
], MandateDetailsFromFieldsDto.prototype, "compensationTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-05-19",
        description: "The date the mandate was issued in ISO format",
    }),
    (0, class_validator_1.IsDateString)({}, { message: "issuedOn must be a valid ISO date string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "issuedOn is required" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], MandateDetailsFromFieldsDto.prototype, "issuedOn", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "This is a sample remark for the mandate.",
        description: "Additional remarks about the mandate",
        maxLength: 1000,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "remarks must be a string" }),
    (0, class_validator_1.MaxLength)(1000, { message: "remarks must be at most 1000 characters" }),
    tslib_1.__metadata("design:type", String)
], MandateDetailsFromFieldsDto.prototype, "remarks", void 0);
class CreateMandateDto {
}
exports.CreateMandateDto = CreateMandateDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 181,
        description: "ID of the opportunity activity",
    }),
    (0, class_validator_1.IsInt)({ message: "opportunityActivityId must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "opportunityActivityId is required" }),
    tslib_1.__metadata("design:type", Number)
], CreateMandateDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: MandateDetailsFromFieldsDto,
        description: "The details of the mandate from fields",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Mandate details are required" }),
    (0, class_transformer_1.Type)(() => MandateDetailsFromFieldsDto),
    tslib_1.__metadata("design:type", MandateDetailsFromFieldsDto)
], CreateMandateDto.prototype, "mandateDetailsFromFields", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [MandateDetailsDocumentDto],
        description: "List of documents associated with the mandate",
        required: false,
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => MandateDetailsDocumentDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateMandateDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 404,
        description: "The statusLid of the LookUp",
    }),
    (0, class_validator_1.IsInt)({ message: "statusLid must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "statusLid is required" }),
    tslib_1.__metadata("design:type", Number)
], CreateMandateDto.prototype, "statusLid", void 0);
class UpdateMandateDto extends (0, mapped_types_1.PartialType)(CreateMandateDto) {
}
exports.UpdateMandateDto = UpdateMandateDto;
